import {
  Box,
  Collapse,
  ListItemButton,
  Typography,
  styled,
  useTheme,
} from "@mui/material";
import { Down, Up } from "assets/Icon";
import React, { useState } from "react";

import { DefaultUrlWeb } from "config/Configuration";
import NumberFormats from "components/NumberFormats";
import { SpaceBetweenBox } from "components/GeneralStyled";

function CoinItem({ coin }) {
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen((v) => !v);
  };

  return (
    <>
      <ListItemButtonStyle onClick={handleClick} open={open}>
        <CoinNameWrapper>
          <img src={DefaultUrlWeb + coin?.coinImageUrl} alt="" />

          <Typography color={open ? "secondary" : "text.main"} variant="h6">
            {coin?.coinName}
          </Typography>
        </CoinNameWrapper>

        <CoinPriceWrapper>
          <Typography
            color={open ? "secondary" : "text.main"}
            variant="h6"
            sx={{ mr: 0.5 }}
          >
            <NumberFormats value={coin?.availableBalance} />
          </Typography>

          {open ? (
            <Up color={theme.palette.secondary.main} />
          ) : (
            <Down color={theme.palette.text.main} />
          )}
        </CoinPriceWrapper>
      </ListItemButtonStyle>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <CoinDetailWrapper>
          <SpaceBetweenBox>
            <Typography variant="subtitle1" color="text.secondary">
              Limit:
            </Typography>
            <Typography variant="h6" color="text.main">
              <NumberFormats value={coin?.tradeLimit || 0} />
            </Typography>
          </SpaceBetweenBox>

          {coin?.totalBalance || coin?.totalBalance === 0 ? (
            <SpaceBetweenBox>
              <Typography variant="subtitle1" color="text.secondary">
                Total:
              </Typography>
              <Typography variant="h6" color="text.main">
                <NumberFormats value={coin?.totalBalance} />
              </Typography>
            </SpaceBetweenBox>
          ) : (
            ""
          )}
        </CoinDetailWrapper>
      </Collapse>
    </>
  );
}

const ListItemButtonStyle = styled(ListItemButton)(({ theme, open }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  transition: "all 0.3s",
  padding: theme.spacing(1),
  borderTop: `1px solid ${
    open ? theme.palette.secondary.main : theme.palette.modules.border
  }`,
}));

const CoinNameWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",

  img: {
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    marginRight: theme.spacing(1),
  },
}));

const CoinPriceWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
}));

const CoinDetailWrapper = styled(Box)(({ theme }) => ({
  background: theme.palette.background.blueBottomToTopGradient,
  padding: theme.spacing(1, 0.5, 0.5),
}));

export default CoinItem;
